export enum OnboardingStatus {
  NotStarted = 0,
  InProgress = 1,
  Completed = 2,
}

export interface OnboardingStatusDto {
  status: OnboardingStatus;
  currentStep: number;
  totalSteps: number;
  isComplete: boolean;
  hasSubscription: boolean;
  hasInvoiceSettings: boolean;
}

export interface HotelDetailsDto {
  hotelName: string;
  country?: string;
  timeZone: string;
  currency: string;
  email?: string;
  phoneNumber?: string;
  phoneNumberCountryCode?: number;
}

export interface ContactInfoDto {
  firstName: string;
  lastName: string;
}

export interface SaveHotelDetailsRequest {
  hotelName: string;
  country?: string;
  timeZone: string;
  currency: string;
  email: string;
  phoneNumber: string;
  phoneNumberCountryCode: number;
}

export interface SaveContactInfoRequest {
  firstName?: string;
  lastName?: string;
}

export interface UpdateProgressRequest {
  step: number;
}
